export default __webpack_public_path__ + "static/media/slide8.c1487987.jpg";